import { Node } from "./shared.model";

export class Flow {
  nodes: { [key: string]: Node };

  constructor() {
    this.nodes = {};
  }

  addNode(node: Node) {
    this.nodes[node.id] = node;
  }

  getNode(id: string): Node | undefined {
    return this.nodes[id];
  }
}

export enum FlowNodeNamesEnum {
  isSenderDomainTrusted = "isSenderDomainTrusted",
  isFromFreeEmailService = "isFromFreeEmailService",
  isTopLevelDomainTrusted = "isTopLevelDomainTrusted",
  dangerousTopLevelDomain = "dangerousTopLevelDomain",
  isFromBlacklistDomain = "isFromBlacklistDomain",
  isPriorContactWithSender = "isPriorContactWithSender",
  getDomainAge = "getDomainAge",
  checkNoReplySender = "checkNoReplySender",
  checkReplyToField = "checkReplyToField",
  isDKIMEnabled = "isDKIMEnabled",
  isSPFConfigured = "isSPFConfigured",
  isItForwardedEmail = "isItForwardedEmail",
  checkDMARCConfiguration = "checkDMARCConfiguration",
  areLinksSecure = "areLinksSecure",
  isDestinationTrustedDomain = "isDestinationTrustedDomain",
  isClearAndDirectLink = "isClearAndDirectLink",
  isExtensionDangerous = "isExtensionDangerous",
  isExtensionRelevantToContext = "isExtensionRelevantToContext",
}
